export default "__VITE_ASSET__Bwi3T01z__"